export const merge = (objectSource, objectDefault) => {
  const resultObject = objectDefault;
  Object.keys(objectSource).map(key => {
    if(objectSource[key])

    resultObject[key] = objectSource[key]

    return key
  })
  return resultObject
}
export const checkCoordinateIsValid = (coordinate) => {
  return coordinate !== undefined
  && coordinate !== null && typeof coordinate === 'number'
}
export const getRandomColor = () => {
  var letters = '0123456789ABCDEF';
  var color = '#';
  for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

export const getPosition = ({ kx, ky, mapProps, extent }, globalMapMode) => {
  const {
    w = 0, h = 0, hor = 0, lat,
    pixelSizes
  } = mapProps;
  if (!globalMapMode) {
    const {
      width, height
    } = pixelSizes
    return [width * kx, height * ky];
  }
  // input parameters
  const angleDegree = hor;
  const width = w;
  const height = h;
  // Array[x,y] x,y - in meters (EPSG:3857)
  const bottomLeftPoint = [extent[0], extent[1]];
  //  Array[x,y] x,y - in meters (EPSG:3857)
  const topRightPoint = [extent[2], extent[3]];

  const xc = (bottomLeftPoint[0] + topRightPoint[0]) / 2;
  const yc = (bottomLeftPoint[1] + topRightPoint[1]) / 2;
  // ---------------------------

  // X-shift of point relative to center (in meters)  (no rotation yet)
  const dx = ((kx - 0.5) * width) / Math.cos((Math.PI / 180) * lat);
  // Y-shift of point relative to center (in meters)  (no rotation yet)
  const dy = ((ky - 0.5) * height) / Math.cos((Math.PI / 180) * lat);

  const phi = (angleDegree / 180) * Math.PI; // angle in radians

  // rotation of shift vector (dx, dy)
  const dx1 = dx * Math.cos(phi) + dy * Math.sin(phi);
  const dy1 = -dx * Math.sin(phi) + dy * Math.cos(phi);

  // output
  const x = xc + dx1;
  const y = yc + dy1;

  return [x, y];
};
